module.exports = __webpack_public_path__ + "img/web_intro_bg.92614f61.jpg";